import { TRUST_WALLET_SLUGS } from '@shared/utils/config/networks';
import { ethers } from 'ethers';
export default function getTrustWalletImage(chain, tokenAddress) {
    var url = "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/".concat(TRUST_WALLET_SLUGS[chain], "/assets/").concat(ethers.utils.isAddress(tokenAddress) ? ethers.utils.getAddress(tokenAddress) : '', "/logo.png");
    return url;
}
export function getDefinedImage(chain, tokenAddress) {
    var base = "https://token-media.defined.fi/".concat(chain, "_").concat(tokenAddress === null || tokenAddress === void 0 ? void 0 : tokenAddress.toLowerCase(), "_thumb.png");
    return base;
}
